// src/pages/customerRejectedRecord/CustomerRejectedThunk.js
import { createAsyncThunk } from "@reduxjs/toolkit";
import { postData } from "../../apiservice/apis";
import dayjs from "dayjs";

export const fetchCustomerRejectedList = createAsyncThunk(
  "customerRejected/fetchList",
  async (filters, { rejectWithValue }) => {
    try {
      const res = await postData("/crm/get-rejected-customer-list", filters);

      return res.data.map((row, index) => ({
        id: row.acc_id,
        no: index + 1,
        acc_name: row.acc_name,
        contact_no: row.contact_no,
        profession: row.profession,
        address: row.address,
        area: row.location_name,
        expectation_per: row.expectation_per,
        email_address: row.email_address,
        date: dayjs(row.created_date).format("DD MMM YYYY"),
        conversation: row.conversation,
        status: row.status_text,
      }));
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);
